import React, {
    useEffect,
    useRef,
    useState
} from "react";

import { Link } from "react-router-dom";

import Collapse from "react-bootstrap/Collapse";

import Select from "react-select";

import Swal from "sweetalert2";

import Loader from "../Loader/loader";

import Pagination from "../Pagenation/Pagenation";

import TransferGatePassServices from "../../../services/TransferGatePassServices";


const TransferGatePass = () => {

    // =====================================================
    // STATES
    // =====================================================

    const [openFilter, setOpenFilter] =
        useState(true);

    const [openList, setOpenList] =
        useState(true);

    const [loading, setLoading] =
        useState(false);

    const [generating, setGenerating] =
        useState(false);


    // =====================================================
    // TRANSFER DATA
    // =====================================================

    const [eligibleTransfers, setEligibleTransfers] =
        useState([]);

    const [selectedTransfer, setSelectedTransfer] =
        useState(null);


    // =====================================================
    // SEARCH / PAGINATION
    // =====================================================

    const [searchQuery, setSearchQuery] =
        useState("");

    const [filteredTransfers, setFilteredTransfers] =
        useState([]);

    const [sort, setSort] =
        useState(10);

    const activePag =
        useRef(0);

    const [, setPaginationRender] =
        useState(0);


    // =====================================================
    // ROW OPTIONS
    // =====================================================

    const options = [

        {
            value: "5",
            label: "5"
        },

        {
            value: "10",
            label: "10"
        },

        {
            value: "20",
            label: "20"
        },

        {
            value: "50",
            label: "50"
        },

        {
            value: "100",
            label: "100"
        }

    ];


    // =====================================================
    // SELECTED ITEMS
    //
    // KEY = transferItemId
    // =====================================================

    const [selectedItems, setSelectedItems] =
        useState({});


    // =====================================================
    // VEHICLE / DRIVER
    // =====================================================

    const [vehicleNo, setVehicleNo] =
        useState("");

    const [driverName, setDriverName] =
        useState("");

    const [driverMobile, setDriverMobile] =
        useState("");

    const [remark, setRemark] =
        useState("");


    // =====================================================
    // FETCH ALL ELIGIBLE TRANSFERS
    // =====================================================

    const fetchEligibleTransfers =
        async (
            showLoader = true
        ) => {

            try {

                if (showLoader) {

                    setLoading(true);

                }


                const response =
                    await TransferGatePassServices
                        .getEligibleTransfers();


                const data =
                    response?.data?.data ||
                    response?.data ||
                    [];


                const transferData =
                    Array.isArray(data)
                        ? data
                        : [];


                setEligibleTransfers(
                    transferData
                );


            } catch (error) {

                console.error(
                    "Eligible Transfer Error:",
                    error
                );


                setEligibleTransfers([]);

                setFilteredTransfers([]);


                Swal.fire(
                    "Error",
                    error?.response?.data?.message ||
                    "Unable to fetch eligible Transfers.",
                    "error"
                );

            } finally {

                if (showLoader) {

                    setLoading(false);

                }

            }

        };


    // =====================================================
    // LOAD ON COMPONENT
    // =====================================================

    useEffect(() => {

        fetchEligibleTransfers();

    }, []);


    // =====================================================
    // FILTER TRANSFERS
    //
    // SEARCH BY:
    // Transfer No
    // From Store
    // To Store
    // Status
    // =====================================================

    useEffect(() => {

        const search =
            String(
                searchQuery || ""
            )
                .trim()
                .toLowerCase();


        if (!search) {

            setFilteredTransfers(
                eligibleTransfers
            );

            activePag.current =
                0;

            setPaginationRender(
                (prev) =>
                    prev + 1
            );

            return;

        }


        const filtered =
            eligibleTransfers.filter(
                (transfer) => {

                    const transferNo =
                        String(
                            transfer?.transferNo ||
                            ""
                        ).toLowerCase();


                    const fromStore =
                        String(
                            transfer
                                ?.storeFrom
                                ?.name ||

                            transfer
                                ?.storeFrom
                                ?.storeName ||

                            ""
                        ).toLowerCase();


                    const toStore =
                        String(
                            transfer
                                ?.storeTo
                                ?.name ||

                            transfer
                                ?.storeTo
                                ?.storeName ||

                            ""
                        ).toLowerCase();


                    const status =
                        String(
                            transfer?.status ||
                            ""
                        ).toLowerCase();


                    return (
                        transferNo.includes(
                            search
                        ) ||

                        fromStore.includes(
                            search
                        ) ||

                        toStore.includes(
                            search
                        ) ||

                        status.includes(
                            search
                        )
                    );

                }
            );


        setFilteredTransfers(
            filtered
        );


        activePag.current =
            0;


        setPaginationRender(
            (prev) =>
                prev + 1
        );


    }, [
        searchQuery,
        eligibleTransfers
    ]);


    // =====================================================
    // PAGINATION
    // =====================================================

    const rowsPerPage =
        Number(sort) ||
        10;


    const pagination =
        Math.max(
            1,
            Math.ceil(
                filteredTransfers.length /
                rowsPerPage
            )
        );


    // =====================================================
    // PAGE SAFETY
    //
    // Example:
    // User is on page 3
    // Then refresh reduces records to 1 page.
    // =====================================================

    useEffect(() => {

        const lastPage =
            Math.max(
                0,
                pagination - 1
            );


        if (
            activePag.current >
            lastPage
        ) {

            activePag.current =
                lastPage;

            setPaginationRender(
                (prev) =>
                    prev + 1
            );

        }

    }, [pagination]);


    const visibleTransfers =
        filteredTransfers.slice(

            activePag.current *
            rowsPerPage,

            (
                activePag.current +
                1
            ) *
            rowsPerPage

        );


    const onPageChange =
        (page) => {

            activePag.current =
                page;


            setPaginationRender(
                (prev) =>
                    prev + 1
            );


            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });

        };


    // =====================================================
    // ROW COUNT CHANGE
    // =====================================================

    const handleRowChange =
        (selectedOption) => {

            const rows =
                Number(
                    selectedOption?.value ||
                    10
                );


            setSort(
                rows
            );


            activePag.current =
                0;


            setPaginationRender(
                (prev) =>
                    prev + 1
            );

        };


    // =====================================================
    // SELECT TRANSFER
    // =====================================================

    const handleSelectTransfer =
        (transfer) => {

            setSelectedTransfer(
                transfer
            );

            setSelectedItems({});

            setVehicleNo("");

            setDriverName("");

            setDriverMobile("");

            setRemark("");


            setTimeout(() => {

                const element =
                    document.getElementById(
                        "gate-pass-items-section"
                    );


                if (element) {

                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });

                }

            }, 100);

        };


    // =====================================================
    // ITEM CHECKBOX
    // =====================================================

    const handleItemSelect = (
        item,
        checked
    ) => {

        const id =
            String(
                item.transferItemId
            );


        setSelectedItems(
            (prev) => {

                const updated = {
                    ...prev
                };


                if (checked) {

                    updated[id] = {

                        transferItemId:
                            item.transferItemId,

                        dispatchQty:
                            Number(
                                item.remainingGatePassQty ||
                                0
                            )

                    };

                } else {

                    delete updated[id];

                }


                return updated;

            }
        );

    };


    // =====================================================
    // CHANGE DISPATCH QTY
    // =====================================================

    const handleDispatchQtyChange = (
        item,
        value
    ) => {

        const id =
            String(
                item.transferItemId
            );


        const qty =
            value === ""
                ? ""
                : Number(value);


        setSelectedItems(
            (prev) => ({

                ...prev,

                [id]: {

                    transferItemId:
                        item.transferItemId,

                    dispatchQty:
                        qty

                }

            })
        );

    };


    // =====================================================
    // SELECT ALL ITEMS
    // =====================================================

    const allItemsSelected =
        selectedTransfer?.items?.length >
        0 &&

        selectedTransfer.items.every(
            (item) =>
                selectedItems[
                    String(
                        item.transferItemId
                    )
                ]
        );


    const handleSelectAll =
        (checked) => {

            if (
                !selectedTransfer?.items
            ) {

                return;

            }


            if (!checked) {

                setSelectedItems({});

                return;

            }


            const allSelected = {};


            selectedTransfer.items.forEach(
                (item) => {

                    allSelected[
                        String(
                            item.transferItemId
                        )
                    ] = {

                        transferItemId:
                            item.transferItemId,

                        dispatchQty:
                            Number(
                                item.remainingGatePassQty ||
                                0
                            )

                    };

                }
            );


            setSelectedItems(
                allSelected
            );

        };


    // =====================================================
    // VALIDATE SELECTED ITEMS
    // =====================================================

    const validateSelectedItems =
        () => {

            if (!selectedTransfer) {

                Swal.fire(
                    "Transfer Required",
                    "Please select a Transfer.",
                    "warning"
                );

                return false;

            }


            const selected =
                Object.values(
                    selectedItems
                );


            if (
                selected.length === 0
            ) {

                Swal.fire(
                    "Item Required",
                    "Please select at least one item.",
                    "warning"
                );

                return false;

            }


            for (
                const selectedItem
                of selected
            ) {

                const originalItem =
                    selectedTransfer
                        .items
                        .find(
                            (item) =>
                                String(
                                    item.transferItemId
                                ) ===
                                String(
                                    selectedItem
                                        .transferItemId
                                )
                        );


                if (!originalItem) {

                    Swal.fire(
                        "Invalid Item",
                        "Selected Transfer item could not be found.",
                        "error"
                    );

                    return false;

                }


                const dispatchQty =
                    Number(
                        selectedItem.dispatchQty
                    );


                const remainingQty =
                    Number(
                        originalItem
                            .remainingGatePassQty ||
                        0
                    );


                if (
                    !Number.isFinite(
                        dispatchQty
                    ) ||
                    dispatchQty <= 0
                ) {

                    Swal.fire(
                        "Invalid Quantity",
                        "Dispatch quantity must be greater than zero.",
                        "warning"
                    );

                    return false;

                }


                if (
                    dispatchQty >
                    remainingQty
                ) {

                    Swal.fire(
                        "Invalid Quantity",
                        `Dispatch quantity cannot exceed remaining quantity ${remainingQty}.`,
                        "warning"
                    );

                    return false;

                }

            }


            return true;

        };


    // =====================================================
    // GENERATE GATE PASS
    // =====================================================

    const handleGenerateGatePass =
        async () => {

            if (
                !validateSelectedItems()
            ) {

                return;

            }


            const selected =
                Object.values(
                    selectedItems
                );


            const confirmation =
                await Swal.fire({

                    title:
                        "Generate Gate Pass?",

                    html:
                        `
                            Transfer No:
                            <b>
                                ${
                                    selectedTransfer
                                        ?.transferNo ||
                                    "-"
                                }
                            </b>

                            <br/>

                            From:
                            <b>
                                ${
                                    selectedTransfer
                                        ?.storeFrom
                                        ?.name ||

                                    selectedTransfer
                                        ?.storeFrom
                                        ?.storeName ||

                                    "-"
                                }
                            </b>

                            <br/>

                            To:
                            <b>
                                ${
                                    selectedTransfer
                                        ?.storeTo
                                        ?.name ||

                                    selectedTransfer
                                        ?.storeTo
                                        ?.storeName ||

                                    "-"
                                }
                            </b>

                            <br/>

                            Selected Items:
                            <b>
                                ${selected.length}
                            </b>
                        `,

                    icon:
                        "question",

                    showCancelButton:
                        true,

                    confirmButtonText:
                        "Yes, Generate",

                    cancelButtonText:
                        "Cancel"

                });


            if (
                !confirmation.isConfirmed
            ) {

                return;

            }


            try {

                setGenerating(
                    true
                );


                const payload = {

                    transferId:
                        selectedTransfer._id,

                    items:
                        selected.map(
                            (item) => ({

                                transferItemId:
                                    item.transferItemId,

                                dispatchQty:
                                    Number(
                                        item.dispatchQty
                                    )

                            })
                        ),

                    vehicleNo:
                        vehicleNo.trim(),

                    driverName:
                        driverName.trim(),

                    driverMobile:
                        driverMobile.trim(),

                    remark:
                        remark.trim()

                };


                const response =
                    await TransferGatePassServices
                        .generateGatePass(
                            payload
                        );


                const created =
                    response?.data?.data ||
                    response?.data;


                const gatePassNo =
                    created?.gatePassNo ||
                    "-";


                await Swal.fire({

                    title:
                        "Gate Pass Generated",

                    html:
                        `
                            Gate Pass No:
                            <b>
                                ${gatePassNo}
                            </b>
                        `,

                    icon:
                        "success",

                    confirmButtonText:
                        "OK"

                });


                // ==========================================
                // RESET
                // ==========================================

                setSelectedTransfer(
                    null
                );

                setSelectedItems({});

                setVehicleNo("");

                setDriverName("");

                setDriverMobile("");

                setRemark("");


                // ==========================================
                // REFRESH ELIGIBLE TRANSFERS
                // ==========================================

                await fetchEligibleTransfers(
                    false
                );


            } catch (error) {

                console.error(
                    "Generate Gate Pass Error:",
                    error
                );


                Swal.fire(
                    "Error",
                    error?.response?.data?.message ||
                    "Unable to generate Gate Pass.",
                    "error"
                );

            } finally {

                setGenerating(
                    false
                );

            }

        };


    // =====================================================
    // CANCEL CURRENT SELECTION
    // =====================================================

    const handleCancelTransferSelection =
        () => {

            setSelectedTransfer(
                null
            );

            setSelectedItems({});

            setVehicleNo("");

            setDriverName("");

            setDriverMobile("");

            setRemark("");

        };


    // =====================================================
    // INITIAL LOADER
    // =====================================================

    if (
        loading
    ) {

        return (
            <Loader />
        );

    }


    // =====================================================
    // UI
    // =====================================================

    return (

        <>

            <div className="row">

                <div className="col-xl-12">


                    {/* =====================================================
                        FILTER
                    ===================================================== */}

                    <div className="filter cm-content-box box-primary">

                        <div className="content-title">

                            <div className="cpa">

                                <i className="fas fa-filter me-2"></i>

                                Filter

                            </div>


                            <div className="tools">

                                <Link
                                    to="#"
                                    className={
                                        `SlideToolHeader ${
                                            openFilter
                                                ? "collapse"
                                                : "expand"
                                        }`
                                    }
                                    onClick={
                                        (e) => {

                                            e.preventDefault();

                                            setOpenFilter(
                                                !openFilter
                                            );

                                        }
                                    }
                                >

                                    <i className="fas fa-angle-up"></i>

                                </Link>

                            </div>

                        </div>


                        <Collapse
                            in={openFilter}
                        >

                            <div className="cm-content-body form excerpt">

                                <div className="card-body">

                                    <div className="row">


                                        {/* SEARCH */}

                                        <div className="col-xl-4 col-xxl-6">

                                            <input
                                                type="text"
                                                className="form-control mb-xl-0 mb-3"
                                                placeholder="Search Transfer No, From Store, To Store or Status"
                                                value={
                                                    searchQuery
                                                }
                                                onChange={
                                                    (e) =>
                                                        setSearchQuery(
                                                            e.target.value
                                                        )
                                                }
                                            />

                                        </div>


                                        {/* ROWS */}

                                        <div className="col-xl-3 col-xxl-6">

                                            <Select
                                                placeholder="Rows per page"
                                                value={
                                                    options.find(
                                                        (option) =>
                                                            Number(
                                                                option.value
                                                            ) ===
                                                            Number(
                                                                sort
                                                            )
                                                    )
                                                }
                                                onChange={
                                                    handleRowChange
                                                }
                                                isSearchable={
                                                    false
                                                }
                                                options={
                                                    options
                                                }
                                                className="custom-react-select mb-3 mb-xxl-0"
                                            />

                                        </div>


                                    </div>

                                </div>

                            </div>

                        </Collapse>

                    </div>



                    {/* =====================================================
                        ELIGIBLE TRANSFER LIST
                    ===================================================== */}

                    <div className="filter cm-content-box box-primary">

                        <div
                            className="
                                content-title
                                d-flex
                                flex-column
                                flex-md-row
                                justify-content-between
                                align-items-center
                                gap-3
                            "
                        >

                            {/* MOBILE HEADER */}

                            <div className="d-flex justify-content-between align-items-center w-100 d-md-none">

                                <div className="cpa">

                                    <i className="fa fa-list me-2"></i>

                                    Eligible Transfers

                                    <span className="badge bg-orange ms-2">

                                        {
                                            filteredTransfers.length
                                        }

                                    </span>

                                </div>


                                <div className="tools">

                                    <Link
                                        to="#"
                                        className={
                                            `SlideToolHeader ${
                                                openList
                                                    ? "collapse"
                                                    : "expand"
                                            }`
                                        }
                                        onClick={
                                            (e) => {

                                                e.preventDefault();

                                                setOpenList(
                                                    !openList
                                                );

                                            }
                                        }
                                    >

                                        <i className="fas fa-angle-up"></i>

                                    </Link>

                                </div>

                            </div>


                            {/* DESKTOP LEFT */}

                            <div className="cpa text-center text-md-start d-none d-md-block">

                                <i className="fa fa-list me-2"></i>

                                Eligible Transfers

                                <span className="badge bg-orange ms-2">

                                    {
                                        filteredTransfers.length
                                    }

                                </span>

                            </div>


                            {/* DESKTOP RIGHT */}

                            <div className="tools d-none d-md-flex align-items-center gap-2">

                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    disabled={
                                        loading ||
                                        generating
                                    }
                                    onClick={() =>
                                        fetchEligibleTransfers()
                                    }
                                >

                                    <i className="fa fa-refresh me-1"></i>

                                    Refresh

                                </button>


                                <Link
                                    to="#"
                                    className={
                                        `SlideToolHeader ${
                                            openList
                                                ? "collapse"
                                                : "expand"
                                        }`
                                    }
                                    onClick={
                                        (e) => {

                                            e.preventDefault();

                                            setOpenList(
                                                !openList
                                            );

                                        }
                                    }
                                >

                                    <i className="fas fa-angle-up"></i>

                                </Link>

                            </div>

                        </div>


                        {/* MOBILE REFRESH */}

                        <div className="row me-0 me-md-3">

                            <div
                                className="
                                    col-12
                                    d-flex
                                    w-100
                                    justify-content-start
                                    justify-content-md-end
                                    ms-3
                                    ms-md-0
                                    me-md-4
                                    mb-2
                                    d-md-none
                                "
                            >

                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm d-flex align-items-center"
                                    disabled={
                                        loading ||
                                        generating
                                    }
                                    onClick={() =>
                                        fetchEligibleTransfers()
                                    }
                                >

                                    <i className="fa fa-refresh me-2"></i>

                                    Refresh

                                </button>

                            </div>

                        </div>


                        <Collapse
                            in={openList}
                        >

                            <div className="cm-content-body form excerpt">

                                <div className="card-body">

                                    <div className="table-responsive">

                                        <div
                                            id="content_wrapper"
                                            className="dataTables_wrapper no-footer"
                                        >

                                            <div className="scrolltable">

                                                <table
                                                    className="
                                                        table
                                                        table-bordered
                                                        table-responsive-lg
                                                        table-striped
                                                        table-condensed
                                                        flip-content
                                                    "
                                                    id="transactions-data"
                                                >

                                                    <thead className="sticky-table-header bg-white">

                                                        <tr>

                                                            <th>
                                                                S.No
                                                            </th>

                                                            <th>
                                                                Transfer No
                                                            </th>

                                                            <th>
                                                                From Store
                                                            </th>

                                                            <th>
                                                                To Store
                                                            </th>

                                                            <th className="text-center">
                                                                Eligible Items
                                                            </th>

                                                            <th className="text-center">
                                                                Already GP Qty
                                                            </th>

                                                            <th className="text-center">
                                                                Remaining Qty
                                                            </th>

                                                            <th className="text-center">
                                                                Status
                                                            </th>

                                                            <th className="text-center">
                                                                Action
                                                            </th>

                                                        </tr>

                                                    </thead>


                                                    <tbody>

                                                        {

                                                            Array.isArray(
                                                                visibleTransfers
                                                            ) &&
                                                            visibleTransfers.length >
                                                            0

                                                                ? (

                                                                    visibleTransfers.map(
                                                                        (
                                                                            transfer,
                                                                            index
                                                                        ) => (

                                                                            <tr
                                                                                key={
                                                                                    transfer?._id ||
                                                                                    index
                                                                                }
                                                                            >

                                                                                <td>

                                                                                    {
                                                                                        activePag.current *
                                                                                        rowsPerPage +
                                                                                        index +
                                                                                        1
                                                                                    }

                                                                                </td>


                                                                                <td>

                                                                                    <strong>

                                                                                        {
                                                                                            transfer
                                                                                                ?.transferNo ||
                                                                                            "-"
                                                                                        }

                                                                                    </strong>

                                                                                </td>


                                                                                <td className="scrollable-description">

                                                                                    {
                                                                                        transfer
                                                                                            ?.storeFrom
                                                                                            ?.name ||

                                                                                        transfer
                                                                                            ?.storeFrom
                                                                                            ?.storeName ||

                                                                                        "-"
                                                                                    }

                                                                                </td>


                                                                                <td className="scrollable-description">

                                                                                    {
                                                                                        transfer
                                                                                            ?.storeTo
                                                                                            ?.name ||

                                                                                        transfer
                                                                                            ?.storeTo
                                                                                            ?.storeName ||

                                                                                        "-"
                                                                                    }

                                                                                </td>


                                                                                <td className="text-center">

                                                                                    <span className="badge bg-primary">

                                                                                        {
                                                                                            transfer
                                                                                                ?.eligibleItemCount ||

                                                                                            transfer
                                                                                                ?.items
                                                                                                ?.length ||

                                                                                            0
                                                                                        }

                                                                                    </span>

                                                                                </td>


                                                                                <td className="text-center">

                                                                                    {
                                                                                        transfer
                                                                                            ?.totalAlreadyGatePassedQty ||
                                                                                        0
                                                                                    }

                                                                                </td>


                                                                                <td className="text-center">

                                                                                    <strong className="text-success">

                                                                                        {
                                                                                            transfer
                                                                                                ?.totalRemainingGatePassQty ||
                                                                                            0
                                                                                        }

                                                                                    </strong>

                                                                                </td>


                                                                                <td className="text-center">

                                                                                    <span className="badge bg-warning text-dark">

                                                                                        {
                                                                                            transfer
                                                                                                ?.status ||
                                                                                            "-"
                                                                                        }

                                                                                    </span>

                                                                                </td>


                                                                                <td className="text-center">

                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-primary btn-xs sharp"
                                                                                        title="Select Items"
                                                                                        onClick={() =>
                                                                                            handleSelectTransfer(
                                                                                                transfer
                                                                                            )
                                                                                        }
                                                                                    >

                                                                                        <i className="fa fa-eye"></i>

                                                                                    </button>

                                                                                </td>

                                                                            </tr>

                                                                        )
                                                                    )

                                                                )

                                                                : (

                                                                    <tr>

                                                                        <td
                                                                            colSpan="9"
                                                                            className="text-center"
                                                                        >

                                                                            No Eligible Transfers Found

                                                                        </td>

                                                                    </tr>

                                                                )

                                                        }

                                                    </tbody>

                                                </table>

                                            </div>


                                            {/* ==========================================
                                                PAGINATION FOOTER
                                            ========================================== */}

                                            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">

                                                <div className="dataTables_info">

                                                    Showing{" "}

                                                    {
                                                        filteredTransfers.length >
                                                        0

                                                            ? activePag.current *
                                                            rowsPerPage +
                                                            1

                                                            : 0
                                                    }

                                                    {" "}to{" "}

                                                    {
                                                        Math.min(

                                                            filteredTransfers.length,

                                                            (
                                                                activePag.current +
                                                                1
                                                            ) *
                                                            rowsPerPage

                                                        )
                                                    }

                                                    {" "}of{" "}

                                                    {
                                                        filteredTransfers.length
                                                    }

                                                    {" "}entries

                                                </div>


                                                <Pagination
                                                    activePage={
                                                        activePag.current
                                                    }
                                                    totalPages={
                                                        pagination
                                                    }
                                                    onPageChange={
                                                        onPageChange
                                                    }
                                                />

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </Collapse>

                    </div>



                    {/* =====================================================
                        SELECTED TRANSFER ITEMS
                    ===================================================== */}

                    {

                        selectedTransfer && (

                            <div
                                id="gate-pass-items-section"
                                className="filter cm-content-box box-primary"
                            >

                                <div className="content-title">

                                    <div className="cpa">

                                        <i className="fa fa-truck me-2"></i>

                                        Gate Pass Items

                                        <span className="badge bg-primary ms-2">

                                            Transfer #

                                            {
                                                selectedTransfer
                                                    .transferNo
                                            }

                                        </span>

                                    </div>

                                </div>


                                <div className="cm-content-body form excerpt">

                                    <div className="card-body">


                                        {/* ==========================================
                                            TRANSFER INFO
                                        ========================================== */}

                                        <div className="row mb-3">

                                            <div className="col-md-4">

                                                <strong>
                                                    From:
                                                </strong>

                                                {" "}

                                                {
                                                    selectedTransfer
                                                        ?.storeFrom
                                                        ?.name ||

                                                    selectedTransfer
                                                        ?.storeFrom
                                                        ?.storeName ||

                                                    "-"
                                                }

                                            </div>


                                            <div className="col-md-4">

                                                <strong>
                                                    To:
                                                </strong>

                                                {" "}

                                                {
                                                    selectedTransfer
                                                        ?.storeTo
                                                        ?.name ||

                                                    selectedTransfer
                                                        ?.storeTo
                                                        ?.storeName ||

                                                    "-"
                                                }

                                            </div>


                                            <div className="col-md-4">

                                                <strong>
                                                    Remaining:
                                                </strong>

                                                {" "}

                                                <span className="text-success">

                                                    {
                                                        selectedTransfer
                                                            ?.totalRemainingGatePassQty ||
                                                        0
                                                    }

                                                </span>

                                            </div>

                                        </div>



                                        {/* ==========================================
                                            ITEM TABLE
                                        ========================================== */}

                                        <div className="table-responsive">

                                            <div className="scrolltable">

                                                <table
                                                    className="
                                                        table
                                                        table-bordered
                                                        table-responsive-lg
                                                        table-striped
                                                        table-condensed
                                                        flip-content
                                                    "
                                                >

                                                    <thead className="sticky-table-header bg-white">

                                                        <tr>

                                                            <th
                                                                className="text-center"
                                                                style={{
                                                                    width:
                                                                        "50px"
                                                                }}
                                                            >

                                                                <input
                                                                    type="checkbox"
                                                                    checked={
                                                                        allItemsSelected
                                                                    }
                                                                    onChange={
                                                                        (e) =>
                                                                            handleSelectAll(
                                                                                e.target.checked
                                                                            )
                                                                    }
                                                                />

                                                            </th>


                                                            <th>
                                                                Part No
                                                            </th>

                                                            <th>
                                                                Description
                                                            </th>

                                                            <th>
                                                                Unit
                                                            </th>

                                                            <th>
                                                                Approved Qty
                                                            </th>

                                                            <th>
                                                                Already GP
                                                            </th>

                                                            <th>
                                                                Remaining
                                                            </th>

                                                            <th>
                                                                Dispatch Qty
                                                            </th>

                                                            <th>
                                                                Assets
                                                            </th>

                                                        </tr>

                                                    </thead>


                                                    <tbody>

                                                        {

                                                            selectedTransfer
                                                                ?.items
                                                                ?.map(
                                                                    (item) => {

                                                                        const id =
                                                                            String(
                                                                                item.transferItemId
                                                                            );


                                                                        const isSelected =
                                                                            !!selectedItems[
                                                                                id
                                                                            ];


                                                                        return (

                                                                            <tr
                                                                                key={
                                                                                    id
                                                                                }
                                                                            >

                                                                                <td className="text-center">

                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={
                                                                                            isSelected
                                                                                        }
                                                                                        onChange={
                                                                                            (e) =>
                                                                                                handleItemSelect(
                                                                                                    item,
                                                                                                    e.target.checked
                                                                                                )
                                                                                        }
                                                                                    />

                                                                                </td>


                                                                                <td>

                                                                                    {
                                                                                        item?.partNo ||

                                                                                        item
                                                                                            ?.inventory
                                                                                            ?.partNo ||

                                                                                        item
                                                                                            ?.inventory
                                                                                            ?.masterItem
                                                                                            ?.partNo ||

                                                                                        "-"
                                                                                    }

                                                                                </td>


                                                                                <td className="scrollable-description">

                                                                                    {
                                                                                        item?.description ||

                                                                                        item
                                                                                            ?.inventory
                                                                                            ?.description ||

                                                                                        item
                                                                                            ?.inventory
                                                                                            ?.masterItem
                                                                                            ?.description ||

                                                                                        "-"
                                                                                    }

                                                                                </td>


                                                                                <td>

                                                                                    {
                                                                                        item?.unitName ||

                                                                                        item
                                                                                            ?.unit
                                                                                            ?.name ||

                                                                                        item
                                                                                            ?.inventory
                                                                                            ?.unit
                                                                                            ?.name ||

                                                                                        item
                                                                                            ?.inventory
                                                                                            ?.masterItem
                                                                                            ?.unit
                                                                                            ?.name ||

                                                                                        "-"
                                                                                    }

                                                                                </td>


                                                                                <td>

                                                                                    {
                                                                                        item.approveQty
                                                                                    }

                                                                                </td>


                                                                                <td>

                                                                                    {
                                                                                        item.alreadyGatePassedQty
                                                                                    }

                                                                                </td>


                                                                                <td>

                                                                                    <strong className="text-success">

                                                                                        {
                                                                                            item.remainingGatePassQty
                                                                                        }

                                                                                    </strong>

                                                                                </td>


                                                                                <td
                                                                                    style={{
                                                                                        minWidth:
                                                                                            "140px"
                                                                                    }}
                                                                                >

                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control form-control-sm"
                                                                                        disabled={
                                                                                            !isSelected
                                                                                        }
                                                                                        min="0.01"
                                                                                        step="0.01"
                                                                                        max={
                                                                                            item.remainingGatePassQty
                                                                                        }
                                                                                        value={
                                                                                            isSelected

                                                                                                ? selectedItems[
                                                                                                    id
                                                                                                ]?.dispatchQty

                                                                                                : ""
                                                                                        }
                                                                                        onChange={
                                                                                            (e) =>
                                                                                                handleDispatchQtyChange(
                                                                                                    item,
                                                                                                    e.target.value
                                                                                                )
                                                                                        }
                                                                                    />

                                                                                </td>


                                                                                <td>

                                                                                    {
                                                                                        item.assetCount ||
                                                                                        0
                                                                                    }

                                                                                </td>

                                                                            </tr>

                                                                        );

                                                                    }
                                                                )

                                                        }

                                                    </tbody>

                                                </table>

                                            </div>

                                        </div>



                                        {/* ==========================================
                                            DISPATCH DETAILS
                                        ========================================== */}

                                        <hr />


                                        <h5 className="mb-3">

                                            Dispatch Details

                                        </h5>


                                        <div className="row">


                                            {/* VEHICLE */}

                                            <div className="col-xl-3 col-md-6 mb-3">

                                                <label className="form-label">

                                                    Vehicle No.

                                                </label>


                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="RJ14AB1234"
                                                    value={
                                                        vehicleNo
                                                    }
                                                    onChange={
                                                        (e) =>
                                                            setVehicleNo(
                                                                e.target.value
                                                                    .toUpperCase()
                                                            )
                                                    }
                                                />

                                            </div>


                                            {/* DRIVER */}

                                            <div className="col-xl-3 col-md-6 mb-3">

                                                <label className="form-label">

                                                    Driver Name

                                                </label>


                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Driver Name"
                                                    value={
                                                        driverName
                                                    }
                                                    onChange={
                                                        (e) =>
                                                            setDriverName(
                                                                e.target.value
                                                            )
                                                    }
                                                />

                                            </div>


                                            {/* MOBILE */}

                                            <div className="col-xl-3 col-md-6 mb-3">

                                                <label className="form-label">

                                                    Driver Mobile

                                                </label>


                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Mobile No."
                                                    value={
                                                        driverMobile
                                                    }
                                                    maxLength="10"
                                                    onChange={
                                                        (e) =>
                                                            setDriverMobile(
                                                                e.target.value.replace(
                                                                    /\D/g,
                                                                    ""
                                                                )
                                                            )
                                                    }
                                                />

                                            </div>


                                            {/* REMARK */}

                                            <div className="col-xl-3 col-md-6 mb-3">

                                                <label className="form-label">

                                                    Remark

                                                </label>


                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Remark"
                                                    value={
                                                        remark
                                                    }
                                                    onChange={
                                                        (e) =>
                                                            setRemark(
                                                                e.target.value
                                                            )
                                                    }
                                                />

                                            </div>

                                        </div>



                                        {/* ==========================================
                                            ACTIONS
                                        ========================================== */}

                                        <div className="d-flex justify-content-end gap-2 mt-3">

                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                disabled={
                                                    generating
                                                }
                                                onClick={
                                                    handleCancelTransferSelection
                                                }
                                            >

                                                Cancel

                                            </button>


                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                disabled={
                                                    generating ||

                                                    Object.keys(
                                                        selectedItems
                                                    ).length ===
                                                    0
                                                }
                                                onClick={
                                                    handleGenerateGatePass
                                                }
                                            >

                                                {

                                                    generating

                                                        ? (

                                                            <>

                                                                <span
                                                                    className="spinner-border spinner-border-sm me-2"
                                                                    role="status"
                                                                />

                                                                Generating...

                                                            </>

                                                        )

                                                        : (

                                                            <>

                                                                <i className="fa fa-file me-2"></i>

                                                                Generate Gate Pass

                                                            </>

                                                        )

                                                }

                                            </button>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        )

                    }

                </div>

            </div>

        </>

    );

};


export default TransferGatePass;